<template>
  <el-tabs class="group_4" v-model="activeTab" style="margin-top:10px">
    <el-tab-pane name="login">
        <template #label>
          <div class="tab-label" :class="{ 'active-tab': activeTab === 'login' }">账号密码登录</div>
        </template>
        <div class="login-content">
          <div class="login-form">
            <el-form :model="loginForm" :rules="loginRules" ref="loginFormRef">
              <el-form-item prop="account">
                <el-input 
                  v-model="loginForm.account" 
                  placeholder="请输入您的账号"
                  class="account-input">
                </el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input 
                  v-model="loginForm.password" 
                  placeholder="请输入您的密码"
                  type="password"
                  :show-password="true"
                  class="password-input">
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-button 
                  @click="handleLogin" 
                  class="login-button"
                  type="primary"
                  :disabled="!isFormValid"
                  :loading="loginLoading">
                  登录
                </el-button>
              </el-form-item>
            </el-form>
          </div>
          
          <!-- 其他登录方式：除注册页外展示 -->
          <OtherLoginMethods v-if="activeTab !== 'signup'" />
        </div>
    </el-tab-pane>
    <el-tab-pane label="注册" name="signup">
      <template #label>
        <div class="tab-label" :class="{ 'active-tab': activeTab === 'signup' }">注册</div>
      </template>
      <el-form :model="registerForm" :rules="registerRules" ref="registerFormRef" class="register-form">
        <el-form-item prop="phone">
          <el-input v-model="registerForm.phone" placeholder="请输入手机号"
            style="width:100%;height:48px;">
            <template #prepend>+86</template>
          </el-input>
        </el-form-item>
        <el-form-item prop="email">
          <div class="code-input-group">
            <el-input v-model="registerForm.email" class="code-input" placeholder="请输入验证码">
            </el-input>
            <el-button 
              @click="sendSmsCodes" 
              class="get-code-button" 
              type="text"
              :disabled="!isRegisterPhoneValid || smsCountdown > 0">
              {{ smsCountdown > 0 ? `已发送(${smsCountdown})` : '获取验证码' }}
            </el-button>
          </div>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="registerForm.password" class="pwd_signup" placeholder="设置您的密码" type="password"
            :show-password="true" style="width:100%;height:48px;">
          </el-input>
        </el-form-item>
        <el-form-item prop="confirmPassword">
          <el-input v-model="registerForm.confirmPassword" class="pwd_signup" placeholder="请再次输入密码" type="password"
            :show-password="true" style="width:100%;height:48px;">
          </el-input>
        </el-form-item>
        
        <el-form-item prop="agree">
          <span style="font-size:medium;margin-left:100px;">
            <el-checkbox style="transform: scale(1.5);" v-model="registerForm.agree"></el-checkbox>
            &nbsp;&nbsp;我已阅读并同意
            <span style="color:deepskyblue;cursor:pointer;">《服务条款》</span>
            和
            <span style="color:deepskyblue;cursor:pointer;">《隐私协议》</span>
          </span>
        </el-form-item>
        <el-form-item>
          <el-button 
            @click="register" 
            class="login-button"
            type="primary"
            :loading="registerLoading">
            注册并登录
          </el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import { sendSmsCode, register } from '@/api/user'
import OtherLoginMethods from '../components/OtherLoginMethods.vue'
export default {
  components: {
    OtherLoginMethods
  },
  data() {
    return {
      activeTab: 'login',
      smsCountdown: 0, // 验证码倒计时
      loginForm: {
        account: '',
        password: '',
        terminal: 4 // 默认终端类型
      },
      loginRules: {
        account: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      registerForm: {
        phone: '',
        email: '',
        password: '',
        confirmPassword: '',
        agree: false
      },
      registerRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度至少为 6 个字符', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { validator: (rule, value, callback) => {
              if (value !== this.registerForm.password) callback(new Error('两次输入的密码不一致'))
              else callback()
            }, trigger: 'blur' }
        ],
        agree: [
          {
            validator: (rule, value, callback) => {
              if (!value) callback(new Error('请同意条款'));
              else callback(); // 验证通过
            }, trigger: 'change'
          }
        ]
      },
      countdownTimer: null, // 倒计时定时器
      loginLoading: false, // 登录按钮loading状态
      registerLoading: false // 注册按钮loading状态
    };
  },
  computed: {
    isFormValid() {
      return this.loginForm.account.trim() !== '' && this.loginForm.password.trim() !== '';
    },
    isRegisterPhoneValid() {
      return this.registerForm.phone.trim() !== '' && /^1[3-9]\d{9}$/.test(this.registerForm.phone);
    }
  },
  beforeDestroy() {
    // 清理定时器，防止内存泄漏
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  },
  methods: {
    sendSmsCodes() {
      // 验证手机号
      if (!this.registerForm.phone) {
        this.$message.error('请输入手机号');
        return;
      }
      
      sendSmsCode({ mobile: this.registerForm.phone, scene: 'ZC' }).then(response => {
        if (response.data.code == 1) {
          this.$message.success('验证码已发送，请注意查收');
          // 开始倒计时
          this.startSmsCountdown();
        }
      }).catch(error => {
        console.error('发送验证码失败:', error);
      });
    },
    startSmsCountdown() {
      // 清除之前的定时器
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
      
      this.smsCountdown = 60;
      this.countdownTimer = setInterval(() => {
        this.smsCountdown--;
        if (this.smsCountdown <= 0) {
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
        }
      }, 1000);
    },
    register() {
      this.$refs.registerFormRef.validate((valid) => {
        if (!valid) return
        
        this.registerLoading = true;
        
        register({ 
          account: this.registerForm.phone, 
          password: this.registerForm.password, 
          sms_code: this.registerForm.email, 
          terminal: 4
        }).then(response => {
          if (response.data.code == 1) {
            this.$message.success('注册成功');
            // 注册成功后切换到登录页面
            setTimeout(() => {
              this.activeTab = 'login';
              // 清空注册表单
              this.$refs.registerFormRef.resetFields();
            }, 1500);
          } else {
            this.$message.error(response.data.msg || '注册失败，请重试');
          }
        }).catch(() => {
          // 错误会被axios拦截器统一处理并显示，这里不需要额外处理
        }).finally(() => {
          this.registerLoading = false;
        });
      })
    },
    async handleLogin() {
      // 表单验证
      if (!this.loginForm.account || !this.loginForm.password) {
        this.$message.error('请输入账号和密码');
        return;
      }
      
      this.loginLoading = true;
      
      try {
        // 使用store action
        await this.$store.dispatch('user/loginAccount', {
          account: this.loginForm.account,
          password: this.loginForm.password,
          scene: 1,
          terminal: 4
        });
        
        // 登录成功，获取用户信息
        const userInfo = await this.$store.dispatch('user/getInfo');
        localStorage.setItem('userInfo', JSON.stringify(userInfo.data));
        this.$message({
          message: '登录成功',
          type: 'success',
          duration: 1000
        });
        this.$router.push('/');
      } catch (error) {
        // 错误已被axios拦截器统一处理并显示，这里不需要额外处理
      } finally {
        this.loginLoading = false;
      }
    },
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
/* 全局溢出控制 */
.group_4 {
  overflow: visible;
  max-width: 100%;
  box-sizing: border-box;
}
/* 登录表单验证错误提示位置 - 避免抖动 */
.login-form ::v-deep .el-form-item__error {
  left: 0;
  position: absolute;
  top: 100%;
  margin-top: -16px;
  font-size: 14px;
  color: #f56c6c;
}

::v-deep .el-tabs__content {
  position: relative;
  margin-top: -2px;
  padding: 0px;
  min-height: 405px;
  height: auto;
  border: none;
  border-top: none;
  border-radius: 0px 0px 20px 20px;
  background: transparent;
  overflow: visible;
}

::v-deep .el-tabs__header {
  border-bottom: none;
  background: transparent;
}

::v-deep .el-tabs__active-bar {
  border-radius: 500px;
  background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%));
}

::v-deep .el-tabs__item {
  width: 50%;
  height: 100%;
  line-height: 62px;
  text-align: center;
  font-size: x-large;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .group_4 {
    width: 100%;
    height: auto;
    margin: 0;
  }

  .login-content {
    padding: 16px;
  }

  .login-form {
    margin-bottom: 20px;
  }

  .login-form ::v-deep .el-form-item {
    margin-bottom: 16px;
  }

  ::v-deep .el-tabs__nav {
    height: 50px;
  }

  ::v-deep .el-tabs__item {
    line-height: 50px;
    font-size: 16px;
  }

  ::v-deep .el-tabs__content {
    min-height: auto;
    padding: 16px 0;
  }

  .tab-label {
    font-size: 16px;
  }

  ::v-deep .account-input .el-input__inner,
  ::v-deep .password-input .el-input__inner {
    height: 44px;
    font-size: 15px;
  }

  .login-button {
    height: 44px;
    font-size: 15px;
  }

  .register-form :deep(.el-form-item) {
    margin-bottom: 14px;
  }

  ::v-deep .pwd_signup .el-input__inner {
    height: 44px;
    font-size: 15px;
  }

  .code-input-group {
    flex-direction: column;
    gap: 10px;
  }

  .code-input {
    width: 100%;
  }

  ::v-deep .code-input .el-input__inner {
    height: 44px;
    font-size: 15px;
  }

  .get-code-button {
    width: 100%;
    height: 44px;
    font-size: 15px;
  }

  ::v-deep .register-form .el-form-item[prop="agree"] span {
    font-size: 13px;
    margin-left: 0 !important;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  ::v-deep .register-form .el-checkbox {
    transform: scale(1.2);
  }
}

@media (max-width: 480px) {
  .login-content {
    padding: 12px;
  }

  ::v-deep .el-tabs__item {
    font-size: 14px;
    line-height: 46px;
  }

  ::v-deep .el-tabs__nav {
    height: 46px;
  }

  .tab-label {
    font-size: 14px;
  }

  ::v-deep .account-input .el-input__inner,
  ::v-deep .password-input .el-input__inner,
  ::v-deep .pwd_signup .el-input__inner,
  ::v-deep .code-input .el-input__inner {
    height: 40px;
    font-size: 14px;
  }

  .login-button,
  .get-code-button {
    height: 40px;
    font-size: 14px;
  }
}

::v-deep .el-tabs__nav {
  display: flex;
  width: 100%;
  height: 62px;
  position: relative;
}

::v-deep .el-tabs__nav::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: rgba(101, 101, 135, 0.40);
}

::v-deep .el-tabs__item:nth-child(1) {
  width: 50%;
  background: none;
  border: none;
  border-radius: 20px 20px 20px 0px;
  clip-path: polygon(0 50%, 50% 0, 100% 50%, 100% 100%, 0 100%);
  position: relative;
}

::v-deep .el-tabs__item:nth-child(1)::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: transparent;
}

::v-deep .el-tabs__item:nth-child(1).is-active {
  width: 50%;
  background: none;
  border: none;
  border-radius: 20px 20px 20px 0px;
  clip-path: polygon(0 0, 100% 0, 100% 50%, 50% 100%, 0 100%);
}

::v-deep .el-tabs__item:nth-child(1).is-active::after {
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
}

::v-deep .el-tabs__item:nth-child(2) {
  width: 50%;
  background: none;
  border: none;
  border-radius: 20px 20px 0px 20px;
  clip-path: polygon(0 50%, 50% 0, 100% 50%, 100% 100%, 0 100%);
  margin-left: 0px !important;
  position: relative;
}

::v-deep .el-tabs__item:nth-child(2)::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: transparent;
}

::v-deep .el-tabs__item:nth-child(2).is-active {
  width: 50%;
  background: none;
  border: none;
  border-radius: 20px 20px 0px 20px;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 50% 100%, 0 50%);
  margin-left: 0px !important;
}

::v-deep .el-tabs__item:nth-child(2).is-active::after {
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
}

::v-deep .el-input-group__append {
  border-radius: 0px 18px 18px 0px;
  font-size: large;
}

::v-deep .el-input-group__prepend {
  border-radius: 18px 0px 0px 18px;
  font-size: x-large;
}

::v-deep .el-input__inner {
  height: 48px;
  font-size: large;
}

::v-deep .phone_login .el-input__inner {
  border-radius: 18px;
}

::v-deep .email_login .el-input__inner {
  border-radius: 18px 0px 0px 18px;
}

::v-deep .email_login .el-input-group__append {
  background-image: linear-gradient(90deg,
      rgba(126, 180, 235, 1) 0,
      rgba(177, 110, 249, 1) 100%);
  color: white;
}

::v-deep .email_signup .el-input__inner {
  border-radius: 8px;
  height: 48px;
}

.tab-label {
  font-size: x-large;
  font-weight: normal;
  color: #333;
}

.active-tab {
  font-weight: bold;
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

::v-deep .pwd_signup .el-input__inner {
  border-radius: 8px;
  height: 48px;
}

::v-deep .pwd_signup .el-input-group__append {
  background-image: linear-gradient(90deg,
      rgba(126, 180, 235, 1) 0,
      rgba(177, 110, 249, 1) 100%);
  color: white;
}

/* 登录内容容器 */
.login-content {
  padding: 20px 35px;
  background: transparent;
  position: relative;
  z-index: 5;
}

/* 登录表单样式 */
.login-form {
  margin-bottom: 25px;
}

.login-form ::v-deep .el-form-item {
  position: relative;
  margin-bottom: 20px;
}

/* 统一注册表单项间距 */
.register-form :deep(.el-form-item) {
  margin-bottom: 16px;
  position: relative;
}

.account-input,
.password-input {
  width: 100%;
  margin-bottom:16px
}

::v-deep .account-input .el-input__inner,
::v-deep .password-input .el-input__inner {
  height: 48px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  font-size: 16px;
  padding: 0 15px;
}

::v-deep .account-input .el-input__inner:focus,
::v-deep .password-input .el-input__inner:focus {
  border-color: #B16EF9;
  box-shadow: 0 0 0 2px rgba(177, 110, 249, 0.2);
}

.login-button {
  width: 100%;
  height: 48px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  background: #BEBEBE;
  border: none;
  cursor: not-allowed;
  transition: all 0.3s ease;
  margin: 0 auto;
}

.login-button:not(:disabled) {
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
  cursor: pointer;
}

.login-button:not(:disabled):hover {
  background: linear-gradient(90deg, #6ba3e8 0%, #a55de8 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(177, 110, 249, 0.3);
}

/* 通用表单项样式已在上面的登录和注册表单中分别定义 */

/* 注册表单验证错误提示位置 - 避免抖动 */
.register-form ::v-deep .el-form-item__error {
  left: 0;
  position: absolute;
  top: 100%;
  margin-top: -16px;
  font-size: 14px;
  color: #f56c6c;
}

/* 与手机验证码登录一致的验证码行布局 */
.code-input-group {
  display: flex;
  gap: 12px;
  align-items: stretch;
}

.code-input {
  flex: 1;
}

::v-deep .code-input .el-input__inner {
  border-radius: 8px;
  height: 48px;
}

.get-code-button {
  width: 120px;
  height: 48px;
  border-radius: 8px;
  font-weight: 500;
  text-align: center;
  font-family: "Source Han Sans CN VF";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%)) !important;
  background-clip: text !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  color: transparent !important;
  background-color: transparent !important;
  box-shadow: 1px 1px 10px 0 rgba(0, 0, 0, 0.05), 4px 4px 20px 0 rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(0px);
  border: none !important;
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.get-code-button:not(:disabled) span,
.get-code-button:not(:disabled) {
  background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%)) !important;
  background-clip: text !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  color: transparent !important;
}

/* 强制覆盖Element UI的hover样式 */
::v-deep .get-code-button:not(.is-disabled):hover,
.get-code-button:not(:disabled):hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(156, 65, 255, 0.3) !important;
  background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%)) !important;
  background-clip: text !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  color: transparent !important;
  background-color: transparent !important;
  border-color: transparent !important;
}

::v-deep .get-code-button:not(.is-disabled):hover span,
.get-code-button:not(:disabled):hover span {
  background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%)) !important;
  background-clip: text !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  color: transparent !important;
}

.get-code-button:disabled {
  cursor: not-allowed;
}

.get-code-button:focus {
  background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%);
}

/* 针对text类型按钮的基础样式 */
.el-button--text.get-code-button {
  background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%)) !important;
  background-clip: text !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  color: transparent !important;
  background-color: transparent !important;
  border: none !important;
}

.el-button--text.get-code-button span {
  background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%)) !important;
  background-clip: text !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  color: transparent !important;
}

/* 额外的Element UI样式覆盖 */
::v-deep .el-button.get-code-button:not(.is-disabled):hover,
.el-button.get-code-button:not(:disabled):hover {
  background-color: transparent !important;
  border-color: transparent !important;
  color: transparent !important;
}

::v-deep .el-button.get-code-button:not(.is-disabled):hover span,
.el-button.get-code-button:not(:disabled):hover span {
  background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%)) !important;
  background-clip: text !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  color: transparent !important;
}

/* 最强制性的样式覆盖 - 针对Element UI的类名 */
.el-button.get-code-button:not(.is-disabled):hover {
  background-color: transparent !important;
  background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%)) !important;
  background-clip: text !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  color: transparent !important;
  border-color: transparent !important;
}

.el-button.get-code-button:not(.is-disabled):hover span {
  background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%)) !important;
  background-clip: text !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  color: transparent !important;
}

/* 使用极高优先级的选择器来覆盖Element UI */
.el-button.el-button--default.get-code-button.el-button--hover,
.el-button.el-button--default.get-code-button:hover {
  background-color: transparent !important;
  background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%)  !important;
  background-clip: text !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  color: transparent !important;
  border-color: transparent !important;
}

.el-button.el-button--default.get-code-button.el-button--hover span,
.el-button.el-button--default.get-code-button:hover span {
  background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%) !important;
  background-clip: text !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  color: transparent !important;
}

/* 最终强制覆盖 - 使用最高优先级 */
.get-code-button[class*="el-button"]:hover,
.get-code-button[class*="el-button--default"]:hover,
.get-code-button[class*="el-button--text"]:hover,
.get-code-button[class*="el-button--hover"] {
  background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%)) !important;
  background-clip: text !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  color: transparent !important;
  background-color: transparent !important;
  border-color: transparent !important;
}

.get-code-button[class*="el-button"]:hover *,
.get-code-button[class*="el-button--default"]:hover *,
.get-code-button[class*="el-button--text"]:hover *,
.get-code-button[class*="el-button--hover"] * {
  background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%)) !important;
  background-clip: text !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  color: transparent !important;
}

/* 针对text类型按钮的特殊覆盖 */
.el-button--text.get-code-button:hover {
  background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%) !important;
  background-clip: text !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  color: transparent !important;
  background-color: transparent !important;
}

.el-button--text.get-code-button:hover span {
  background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%) !important;
  background-clip: text !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  color: transparent !important;
}

</style>